import { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PillTriggerButton, {
  PILL_TRIGGER_VARIANT,
} from "../Buttons/PillTriggerButton";
import { INPUT_COLOR_BORDER } from "../../utils/colors";

const FilterSelect = ({
  value,
  onChange,
  options = [],
  placeholder = "",
  icon = null,
  disabled = false,
  sx = {},
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const selectedOption = options.find((option) => option.value === value);
  const displayText = selectedOption?.label ?? placeholder;

  const onMenuClose = () => setAnchorEl(null);

  const onOptionClick = (option) => {
    onChange?.({ target: { value: option.value } });
    onMenuClose();
  };

  return (
    <>
      <PillTriggerButton
        variant={PILL_TRIGGER_VARIANT.PILL}
        text={displayText}
        startIcon={icon}
        disabled={disabled}
        isActive={isMenuOpen}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={sx}
      />
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={onMenuClose}
        MenuListProps={{ sx: { maxHeight: 300, overflow: "auto" } }}
        PaperProps={{
          sx: {
            border: `1px solid ${INPUT_COLOR_BORDER}`,
            boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
          },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === value}
            onClick={() => onOptionClick(option)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default FilterSelect;
